module.exports = __webpack_public_path__ + "img/certificate-01.59a4d84f.svg";